var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHonestyIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 88,
    height: 98,
    viewBox: "0 0 88 98",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2480_5605)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.9276 86.2249C67.1439 85.301 69.855 83.7428 72.1307 82.7362C72.4473 82.5983 72.6848 82.419 72.8826 82.2122C75.1979 79.6888 77.1174 77.2343 79.0963 74.6144C79.6306 73.9111 79.3535 73.0286 78.4432 72.546C78.4037 72.5322 78.3641 72.5046 78.3443 72.4908C76.1478 71.3325 73.041 71.6359 71.3193 73.1389C70.0133 74.2834 68.6875 75.29 67.4012 76.3104C67.1044 76.5448 66.7284 76.7103 66.3128 76.8068C60.6928 78.0203 55.7655 79.0131 52.8566 82.0743C50.2445 84.8597 49.2946 88.5415 50.2642 91.8371C50.5215 92.7472 50.6007 93.6986 50.3236 94.6087C50.1257 95.2568 49.9278 96.5254 49.7695 97.6148",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8495 67.9401C76.5619 65.8855 77.2347 63.6793 77.769 61.2661C78.2637 59.0323 80.8758 57.3224 84.1014 57.1156H84.1805C85.5855 57.0191 86.753 57.7913 86.753 58.7703C86.7135 68.2711 86.8124 82.3637 83.8045 85.549C80.6779 88.8308 73.4353 93.2709 68.0726 97.1043C67.8747 97.256 67.6966 97.4215 67.5977 97.6283",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0721 86.2249C20.8558 85.301 18.1447 83.7428 15.869 82.7362C15.5524 82.5983 15.3149 82.419 15.1171 82.2122C12.8018 79.6888 10.8823 77.2343 8.90343 74.6144C8.36914 73.9111 8.64618 73.0286 9.55646 72.546C9.59603 72.5322 9.63561 72.5046 9.6554 72.4908C11.8519 71.3325 14.9587 71.6359 16.6804 73.1389C17.9864 74.2834 19.3122 75.29 20.5985 76.3104C20.8953 76.5448 21.2713 76.7103 21.6869 76.8068C27.3068 78.0203 32.2342 79.0131 35.1431 82.0743C37.7552 84.8597 38.7051 88.5415 37.7355 91.8371C37.4782 92.7472 37.399 93.6986 37.6761 94.6087C37.874 95.2568 38.0719 96.5254 38.2302 97.6148",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1496 67.9538C11.4372 65.8992 10.7644 63.6929 10.2301 61.2798C9.73541 59.046 7.12331 57.3361 3.89777 57.1293H3.81861C2.41362 57.0327 1.24609 57.8049 1.24609 58.784C1.28567 68.2847 1.18673 82.3773 4.1946 85.5764C7.3212 88.8583 14.5638 93.2984 19.9265 97.1318C20.1244 97.2835 20.3025 97.4627 20.4015 97.6558",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6 6.21948V15.0722C63.224 29.8266 43.9894 33.1912 43.9894 33.1912C43.9894 33.1912 24.7351 29.6887 24.3789 15.8857V6.23327C33.7587 5.99885 41.5554 3.80636 44.1873 0.855469C46.7796 3.76499 54.3982 5.94369 63.6197 6.21948H63.6Z",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5 15.5684L42.0896 20.698",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8549 12.6719L42.0898 20.6972",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.95312 38.8313C7.95312 35.715 11.5744 33.1777 16.0665 33.1777C20.5585 33.1777 24.1798 35.715 24.1798 38.8313C24.1798 41.9477 20.5585 44.4849 16.0665 44.4849C11.5744 44.4849 7.95312 41.9477 7.95312 38.8313Z",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.82031 53.682C3.82031 50.4967 7.54057 47.9043 12.1513 47.9043H20.0074C24.5984 47.9043 28.3384 50.4967 28.3384 53.682",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.7773 38.8313C63.7773 35.715 67.3987 33.1777 71.8907 33.1777C76.3827 33.1777 80.004 35.715 80.004 38.8313C80.004 41.9477 76.3827 44.4849 71.8907 44.4849C67.3987 44.4849 63.7773 41.9477 63.7773 38.8313Z",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6445 53.682C59.6445 50.4967 63.3846 47.9043 67.9755 47.9043H75.8316C80.4424 47.9043 84.1626 50.4967 84.1626 53.682",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.875 43.8216C35.875 40.7052 39.4963 38.168 43.9883 38.168C48.4804 38.168 52.1017 40.7052 52.1017 43.8216C52.1017 46.9379 48.4804 49.4751 43.9883 49.4751C39.4963 49.4751 35.875 46.9379 35.875 43.8216Z",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7227 58.6878C31.7227 55.5025 35.4627 52.9102 40.0537 52.9102H47.9097C52.5007 52.9102 56.2408 55.5025 56.2408 58.6878",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2480_5605"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 98,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHonestyIcon);
export default __webpack_public_path__ + "static/media/honesty-icon.fa178e32.svg";
export { ForwardRef as ReactComponent };